import type { CSSProperties } from 'react';

import type { AlignType } from '../types';

export const getTextAlignStyle = (align?: AlignType): Pick<CSSProperties, 'textAlign'> => {
  if (!align)
    return {
      textAlign: 'inherit',
    };

  const values: Record<AlignType, CSSProperties['textAlign']> = {
    left: 'left',
    center: 'center',
    right: 'right',
    justify: 'justify',
    column_dynamic: undefined,
  };

  return {
    textAlign: values[align],
  };
};

export const getTextAlignStyleVariables = ({
  mobileAlign,
  desktopAlign,
}: {
  mobileAlign?: AlignType;
  desktopAlign?: AlignType;
}): CSSProperties => {
  const values: Record<AlignType, CSSProperties['textAlign']> = {
    left: 'left',
    center: 'center',
    right: 'right',
    justify: 'justify',
    column_dynamic: undefined,
  };

  return {
    ...(mobileAlign ? { '--mobile-text-align': values[mobileAlign] } : {}),
    ...(desktopAlign ? { '--text-align': values[desktopAlign] } : {}),
  } as CSSProperties;
};
